import { useEffect } from 'react';
import PageHeader from '../../components/PageHeader';
import { RESEARCH_MATH, MATH_CARD_KPI } from '../../config/data';
import { t } from '../../utils/i18n';
import '../MedicalAIPage/index.css';

export default function MathPage() {
    useEffect(() => {
        document.title = t('数学智能 · 至知创新研究院', 'Mathematical AI · IQuest Research');
    }, []);
    return (
        <div className="page-shell">
            <PageHeader
                eyebrow={t('数学智能 · Mathematical AI', 'Mathematical AI')}
                title={t(
                    '构建从自然语言到形式化数学的全链条 AI 能力体系',
                    'End-to-end AI system from natural language to formal mathematics'
                )}
                subtitle={t(
                    '以推理策略、形式化验证、引理检索为锚点，与北京大学国际数学研究中心共建研究范式。',
                    'Reasoning strategies · Formal verification · Lemma retrieval — in partnership with Center for Machine Learning Research Peking University'
                )}
            />
            <section className="section product-grid-section">
                <div className="container">
                    <div className="product-grid product-grid-3">
                        {RESEARCH_MATH.map((item, idx) => (
                            <article className="product-card" key={item.id ?? idx}>
                                <div className="product-card-img">
                                    <img src={item.img} alt={item.title} loading="lazy" decoding="async" />
                                </div>
                                <div className="product-card-body">
                                    <div className="product-card-title">{item.title}</div>
                                    <p className="product-card-desc">{item.desc}</p>
                                    {MATH_CARD_KPI[idx] && (
                                        <div className="product-card-kpi">{MATH_CARD_KPI[idx]}</div>
                                    )}
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
